var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flecha_abajo_circular-llena 1",
    clipPath: "url(#clip0_537_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.25 4.53192C23.1353 5.62049 24.7037 7.18258 25.7998 9.06355C26.8959 10.9445 27.4817 13.0791 27.4993 15.2561C27.5169 17.4331 26.9656 19.5769 25.9 21.4753C24.8345 23.3737 23.2916 24.9609 21.4241 26.0798C19.5566 27.1987 17.4292 27.8104 15.2526 27.8545C13.076 27.8986 10.9257 27.3734 9.01444 26.331C7.1032 25.2886 5.49734 23.7651 4.35583 21.9113C3.21433 20.0576 2.57676 17.9378 2.50625 15.7619L2.5 15.3569L2.50625 14.9519C2.57625 12.7932 3.20443 10.6894 4.32955 8.84566C5.45466 7.00195 7.03832 5.48124 8.92612 4.43177C10.8139 3.38231 12.9414 2.83992 15.1013 2.85747C17.2611 2.87502 19.3795 3.45192 21.25 4.53192ZM15 9.10692C14.6685 9.10692 14.3505 9.23862 14.1161 9.47304C13.8817 9.70746 13.75 10.0254 13.75 10.3569V17.3382L10.8837 14.4732L10.7662 14.3694C10.515 14.1752 10.1992 14.0838 9.88309 14.1139C9.56694 14.144 9.2741 14.2934 9.06406 14.5316C8.85402 14.7698 8.74252 15.079 8.75221 15.3964C8.76191 15.7139 8.89207 16.0157 9.11625 16.2407L14.1163 21.2407C14.1512 21.2757 14.1875 21.3082 14.2338 21.3444L14.3488 21.4244L14.4712 21.4894L14.5725 21.5319L14.7137 21.5744L14.8538 21.5994L15 21.6069L15.1437 21.5982L15.2863 21.5732L15.4638 21.5182L15.605 21.4507L15.7438 21.3619C15.7935 21.3253 15.8403 21.2847 15.8837 21.2407L20.8838 16.2407L20.9875 16.1232C21.1818 15.8719 21.2731 15.5562 21.243 15.24C21.2129 14.9239 21.0636 14.631 20.8253 14.421C20.5871 14.2109 20.2779 14.0994 19.9605 14.1091C19.643 14.1188 19.3412 14.249 19.1163 14.4732L16.25 17.3369V10.3569L16.2413 10.2107C16.2054 9.90661 16.0593 9.62626 15.8305 9.42281C15.6017 9.21937 15.3062 9.10696 15 9.10692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.356934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha);
export default __webpack_public_path__ + "static/media/Flecha.e63b4b7bebb3cc3f831319216d23d5e1.svg";
export { ForwardRef as ReactComponent };